import store from '../store'

export const TimeUtils = {
    getCurrentTime: function () {
        return Math.floor(new Date() / 1000) - store.state.timeDiff
    },
    secondsToMinutes: function (seconds) {
        return Math.floor(seconds / 60)
    },
    secondsToHours: function (seconds) {
        return Math.floor(seconds / 60 / 60)
    },
    timeUntilFutureTimestamp: function (futureTime) {
        const currentTimestamp = this.getCurrentTime()
        return futureTime - currentTimestamp
    },
    secondsToTimeObject: function (seconds) {
        let minutes = TimeUtils.secondsToMinutes(seconds)
        let hours = TimeUtils.secondsToHours(seconds)
        let days = Math.floor(hours / 24)
        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }
    },
    timeUntilFuture: function (futureSeconds) {
        const currentTime = this.getCurrentTime()
        let seconds = futureSeconds - currentTime
        return this.secondsToTimeObject(seconds)
    },

    minutesUntil (futureSeconds) {
        let until = this.timeUntilFutureTimestamp(futureSeconds)
        return this.secondsToMinutes(until)
    },

    getCurrentMonth () {
        const quizDate = new Date(Date.now())
        const monthString = ('0' + (quizDate.getMonth() + 1)).slice(-2)
        const yearString = quizDate.getFullYear().toString().substr(-2)
        return `${monthString}-${yearString}`
    },

    timesampToMonthName (timestamp) {
        return this.getMonthName(new Date(timestamp * 1000).getMonth())
    },

    getMonthName (jsMonthNumber = 0) {
        try {
            let d = new Date()
            d.setMonth(jsMonthNumber)
            return d.toLocaleDateString('hr-HR', { month: 'long' })
        } catch (error) { }
        return ''
    },

    getCurrentMonthLongName () {
        return new Date().toLocaleDateString('hr-HR', { month: 'long' })
    },

    localiseHours (hours) {
        switch (hours) {
        case 0:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
            return 'sati'
        case 1:
        case 21:
            return 'sat'
        case 2:
        case 3:
        case 4:
        case 22:
        case 23:
            return 'sata'
        }
    }
}

export function DDHHMMSSCounterValues (counter) {
    let leftValue
    let rightValue
    let leftDesc
    let rightDesc
    if (counter.days > 0) {
        leftValue = counter.days
        rightValue = counter.hours % 24

        leftDesc = leftValue > 1 ? 'dana' : 'dan'
        rightDesc = TimeUtils.localiseHours(rightValue)
    } else if (counter.hours > 0) {
        leftValue = counter.hours
        rightValue = counter.minutes % 60

        leftDesc = TimeUtils.localiseHours(leftValue)
        rightDesc = 'min'
    } else {
        leftValue = counter.minutes
        rightValue = counter.seconds % 60

        leftDesc = 'min'
        rightDesc = 'sek'
    }
    return {
        leftValue,
        rightValue,
        leftDesc,
        rightDesc
    }
}
